import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <p>The matrix will then indicate whether you should: stop doing
                                                this, start doing this, continue with
                                                what you are doing or ignore it.</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">IMPACT MANAGEMENT MATRIX</span>

                                            </div>
                                            <div className="mobile-scroll md-lg-scroll">
                                                <div className="matrixdiagram">


                                                    <div className="matrixrow1">
                                                        <div className="matrixerow1cell"><textarea
                                                            className="matrixTextArea" rows="10" cols="5"
                                                            id="impact_stop"
                                                            onBlur="saveImpactMatrix(this.value,300,this.id);"></textarea>
                                                        </div>
                                                        <div className="matrixerow2cell"><textarea
                                                            className="matrixTextArea" id="impact_continue"
                                                            onBlur="saveImpactMatrix(this.value,300,this.id);"></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="matrixerow2">
                                                        <div className=" matrixerow1cell"><textarea
                                                            className="matrixTextArea" rows="10" cols="5"
                                                            id="impact_ignore"
                                                            onBlur="saveImpactMatrix(this.value,300,this.id);"></textarea>
                                                        </div>
                                                        <div className="matrixerow2cell"><textarea
                                                            className="matrixTextArea" rows="10" cols="5"
                                                            id="impact_start"
                                                            onBlur="saveImpactMatrix(this.value,300,this.id);"></textarea>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <br/>
                                                <div className="circle_title"><img
                                                    src={require('@images/browndot.jpg')}
                                                    alt=""/>NEXT STEPS</div>
                                                <p>Now that you have considered the factors involved in managing
                                                    your impact and have some practical tools to consider, it is
                                                    worth thinking about what to do next. Here are a number of
                                                    suggestions to maintain momentum (although these are by no
                                                    means exhaustive):</p>
                                                <div className="border_subtitle">Look for opportunities to
                                                    practise
                                                </div>
                                                <p>Think about the opportunities that you have in your current
                                                    work, or beyond, where you can practise role modelling good
                                                    behaviour or improving your profile.</p>


                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page7')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div onClick={this.props.handleChangePage('Page9')}
                                                         className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }